<template lang="html">
    <div class="panel panel-default chart-container">

      <div class="panel-heading text-center">
        <!-- <button class="btn btn-default btn-sm pull-left refresh-button" style="display: inline;"
                @click="refresh">
          <i class="fas fa-sync-alt"></i>
        </button> -->
        <h5 class="chart-title" style="display: inline-block">{{ title }}</h5>
        <button class="btn btn-warning btn-sm pull-right export-button" style="display: inline;"
              data-toggle="tooltip"
              data-placement="top"
              title="Export this chart's data as CSV"
              v-if="this.$store.getters.filteredStats.length > 0"
              @click.stop="exportCSV(reportName)">
        <i class="fas fa-download"></i>
      </button>
      </div>

      <div class="panel-body">

        <!-- Error Message -->
        <p class="text-center text-danger" v-if="errorBag.message">
          <i class="fas fa-exclamation-triangle"></i>
          <small>
            <strong>{{ errorBag.message }}</strong>
          </small>
        </p>
        <!-- Error Message -->

        <div class="chart-controls" v-else>

          <!-- Qualifying Progress -->
          <div class="input-group input-group-sm pull-left">
            <span class="input-group-addon">Qualifying Prog. %</span>

            <input type="number" class="form-control" placeholder="Min. %" min="0" max="100"
                    v-model="qualPercent" @change="refresh">

            <span class="input-group-addon" style="border-left: 0 !important;">%</span>

            <span class="input-group-addon">
              Include '<span class="red">{{ qualPercent }}%</span>'ers?
              <input type="checkbox" aria-label="..." v-model="includeQual" @change="refresh">
            </span>
          </div>
          <!-- Qualifying Progress -->
        </div>

        <canvas width="420" height="200" ref="canvas"></canvas>
      </div>

      <div class="panel-footer">
        <div class="text-muted text-center">
          <i class="fas fa-info-circle"></i>
          <small>{{ info }}</small>
        </div>
      </div>

    </div>
</template>

<script>
import BaseChart from '@/components/dashboard/charts/BaseChart'

export default BaseChart.extend({
  name: 'polar-area-chart',

  data () {
    return {
      type: 'polarArea',
      qualPercent: 90,
      includeQual: true,
      chartOptions: {
        responsive: true,
        maintainAspectRatio: true,
        animation: {
          animateRotate: true,
          animateScale: true
        },
        cutoutPercentage: 0
      }
    }
  },

  computed: {
    group () {
      return this.$store.state.selectedGroup
    },

    groupCourses () {
      return this.$store.state.selectedGroupCourses
    },

    groupCoursesStats () {
      return this.$store.state.stats
    },

    values () {
      return Object.values(this.$store.getters.polarAreaChartData(this.qualPercent, this.includeQual))
    },

    labels () {
      return Object.keys(this.$store.getters.polarAreaChartData(this.qualPercent, this.includeQual))
    },

    chartData () {
      return {
        type: this.type,
        data: {
          labels: this.labels,
          datasets: [{
            data: this.values,
            backgroundColor: this.getColors('transparent', this.values.length),
            borderColor: this.getColors('solid', this.values.length),
            borderWidth: 1
          }]
        },
        options: this.chartOptions
      }
    }
  },

  beforeDestroy () {
    /** Remove any event listeners */
    this.eventHub.$off('groupCourseCohortFilterUpdated')
  },

  mounted () {
    /** Listen for when Progress Buckets are updated */
    this.eventHub.$on('groupCourseCohortFilterUpdated', this.refresh)

    this.errorCheck()

    this.render(this.chartData)
  },

  methods: {
    errorCheck () {
      if (
        // eslint-disable-next-line
        _.isEqual(this.$store.state.selectedGroup, {}) ||
        this.$store.state.selectedGroupCourses.length === 0
      ) {
        this.errorBag = {
          status: 'danger',
          message: 'Please select at least 1 Group and 1 Course at the top.'
        }
      } else {
        this.errorBag = {
          status: '',
          message: ''
        }
      }
    },

    selectChartCourse () {
      this.refresh()
    },

    changeQualPercent () {
      this.refresh()
    }
  }
})
</script>

<style lang="scss" scoped>
.red {
  font-size: 1em
}

.export-button {
  display: inline;
  background-color: rgba(255, 104, 0, 0.90) !important;
  border: 1px solid rgba(255, 104, 0, 1.00) !important;
}

.export-button {
  display: none !important;
}

.chart-container canvas {
  max-width: 420px;
  max-height: 200px;
}

.chart-container .panel-footer {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/charts/PolarAreaChart.vue